// --------------------------------------------------------------------------------
// NOTE: This file was automatically generated, do not modify manually.
// --------------------------------------------------------------------------------
import { Aerodrome } from './Aerodrome';
import { Coordinate } from './Coordinate';
import { FlightPlan } from './FlightPlan';
import { PathPoint } from './PathPoint';
import { PathPointLoadClassification } from './PathPointLoadClassification';

export class Flight implements IFlight {
    id!: string;
    aircraft!: string;
    aerodromeDeparture!: Aerodrome;
    aerodromeDestination!: Aerodrome;
    currentflightPlan!: FlightPlan;
    filedflightPlan!: FlightPlan;
    regulatedflightPlan!: FlightPlan;

    constructor(data?: IFlight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.aircraft = _data["aircraft"];
            this.aerodromeDeparture = _data["aerodromeDeparture"] ? Aerodrome.fromJS(_data["aerodromeDeparture"]) : <any>undefined;
            this.aerodromeDestination = _data["aerodromeDestination"] ? Aerodrome.fromJS(_data["aerodromeDestination"]) : <any>undefined;
            this.currentflightPlan = _data["currentflightPlan"] ? FlightPlan.fromJS(_data["currentflightPlan"]) : <any>undefined;
            this.filedflightPlan = _data["filedflightPlan"] ? FlightPlan.fromJS(_data["filedflightPlan"]) : <any>undefined;
            this.regulatedflightPlan = _data["regulatedflightPlan"] ? FlightPlan.fromJS(_data["regulatedflightPlan"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Flight {
        data = typeof data === 'object' ? data : {};
        let result = new Flight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["aircraft"] = this.aircraft;
        data["aerodromeDeparture"] = this.aerodromeDeparture ? this.aerodromeDeparture.toJSON() : <any>undefined;
        data["aerodromeDestination"] = this.aerodromeDestination ? this.aerodromeDestination.toJSON() : <any>undefined;
        data["currentflightPlan"] = this.currentflightPlan ? this.currentflightPlan.toJSON() : <any>undefined;
        data["filedflightPlan"] = this.filedflightPlan ? this.filedflightPlan.toJSON() : <any>undefined;
        data["regulatedflightPlan"] = this.regulatedflightPlan ? this.regulatedflightPlan.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFlight {
    id: string;
    aircraft: string;
    aerodromeDeparture: Aerodrome;
    aerodromeDestination: Aerodrome;
    currentflightPlan: FlightPlan;
    filedflightPlan: FlightPlan;
    regulatedflightPlan: FlightPlan;
}